import React from "react";
import {
    ArrowPathIcon,
    CheckCircleIcon,
    ExclamationTriangleIcon,
    TrashIcon,
    XCircleIcon
} from "@heroicons/react/24/outline";
import { useDarkMode } from "../../contexts/darkModeContext";

const notificationTypes = {
    warning: {
        color: "yellow",
        icon: <ExclamationTriangleIcon className="size-5 stroke-2 text-yellow-600" />,
        borderColor: "border-yellow-600",
        bgColor: "bg-yellow-600/25",
        textColor: "text-yellow-600",
        linkHover: "hover:text-yellow-600",
        barColor: "bg-yellow-600",
        barBg: "bg-yellow-400",
    },
    success: {
        color: "green",
        icon: <CheckCircleIcon className="size-5 stroke-2 text-green-600" />,
        borderColor: "border-green-600",
        bgColor: "bg-green-600/25",
        textColor: "text-green-600",
        linkHover: "hover:text-green-600",
        barColor: "bg-green-600",
        barBg: "bg-green-400",
    },
    error: {
        color: "red",
        icon: <XCircleIcon className="size-5 stroke-2 text-red-600" />,
        borderColor: "border-red-600",
        bgColor: "bg-red-600/25",
        textColor: "text-red-600",
        linkHover: "hover:text-red-600",
        barColor: "bg-red-600",
        barBg: "bg-red-400",
    },
    delete: {
        color: "red",
        icon: <TrashIcon className="size-5 stroke-2 text-red-600" />,
        borderColor: "border-red-600",
        bgColor: "bg-red-600/25",
        textColor: "text-red-600",
        linkHover: "hover:text-red-600",
        barColor: "bg-red-600",
        barBg: "bg-red-400",
    },
    update: {
        color: "blue",
        icon: <ArrowPathIcon className="size-5 stroke-2 text-blue-600" />,
        borderColor: "border-blue-600",
        bgColor: "bg-blue-600/25",
        textColor: "text-blue-600",
        linkHover: "hover:text-blue-600",
        barColor: "bg-blue-600",
        barBg: "bg-blue-400",
    },

};

const Notification = ({ type = "warning", message, linkText, isVisible }) => {
    const { darkMode } = useDarkMode();
    const config = notificationTypes[type] || notificationTypes.warning;

    return (
        <div className={`absolute z-50 w-fit right-4 top-4 border-l-4 rounded-r-xl ${isVisible ? "animate-slideInRightBounce" : "animate-slideOutRightBounce"} drop-shadow-2xl ${config.borderColor} ${darkMode ? 'bg-bgDark' : 'bg-white'}`}>
            <div className={`${config.bgColor} w-full h-full p-4 rounded-r-xl`}>
                <div className="flex">
                    <div className="shrink-0">{config.icon}</div>
                    <div className="ml-3">
                        <p className={`flex text-sm ${config.textColor}`}>
                            {message}{" "}
                            <div className={`ml-2 font-medium ${config.textColor} ${config.linkHover}`}>
                                {linkText}
                            </div>
                        </p>
                    </div>
                </div>

                {/* Loading bar */}
                <div className={`relative mt-2 h-1 w-full rounded-full ${config.barBg} overflow-hidden`}>
                    <div className={`absolute left-0 top-0 h-full rounded-full ${config.barColor} animate-fill-bar`}></div>
                </div>
            </div>
        </div>

    );
};

export default Notification;
